import React, { useState, useEffect } from 'react';
import { Popover } from '@barges/react';
import { analyticsService } from '@common/analytics';
import classes from '../classes.module.scss';
import RateSection from '../rate_section';
import RateReview from '..';
import withPGTranslation from '../../../config/withPGTranslation';
import { rateReviewTheme } from '../../../config/const';
import { isMobile } from '../../../config/util';

function RateReviewAfterChat({
  visible,
  onCancel,
  orderId,
  advisorName,
  t,
  clickSource,
  advisorId,
  profileLanguage,
  createdAt,
  chatType
}) {
  const [like, setLike] = useState(null);
  const [showSmallModal, setShowSmallModal] = useState(false);
  const [showFullModal, setShowFullModal] = useState(false);

  useEffect(() => {
    setShowSmallModal(visible);
    if (visible) analyticsService.trackPageVisit('live session ended review draw');
  }, []);

  const onSkipClick = () => {
    setLike(null);
    setShowSmallModal(false);
    onCancel(like);
  };

  const renderSkipButton = () => (
    <div className={ classes.skipTopButtonContainer }>
      <button type ="button" className={ classes.skipTopButton } onClick={ onSkipClick }>
        { t('rate_review.skip') }
      </button>
    </div>
  );

  const fullModalOnCancel  = () => {
    setShowFullModal(false);
    onCancel(like);
  };

  const renderFullModal = () => (
    <RateReview
      visible={ showFullModal }
      onCancel={ fullModalOnCancel }
      existingLike={ like }
      advisorName={ advisorName }
      orderId={ orderId }
      advisorId={ advisorId }
      profileLanguage={ profileLanguage }
      createdAt={ createdAt }
      clickSource={ clickSource }
      chatType={ chatType }
    />
  );

  const renderSmallModalContent = () => (
    <div className={ classes.smallModalContentContainer }>
      <RateSection
        value={ like }
        onSmallModal
        onValueChanged={ (liked) => {
          setLike(liked);
          setShowSmallModal(false);
          setShowFullModal(true);
        } }
      />
      { renderSkipButton() }
    </div>
  );

  const renderSmallModal = () => (
    <Popover
      isOpen={ showSmallModal }
      // theme={ appGeneralPopupTheme.BOTTOM }
      className="rate-review-after-chat-popover"
    >
      { renderSmallModalContent() }
    </Popover>
  );

  const renderMobileView = () => (
    <div>
      {renderSmallModal()}
      {renderFullModal()}
    </div>
  );

  const onCloseButtonAction = () => {
    onCancel(like);
  };

  const renderBrowserViewFull = () => (
    <Popover
      onCloseButtonClick={ onCloseButtonAction }
      closable
      isOpen={ visible }
      className={ classes.rateReviewChatEndedPopoverContainer }
      contentClassName={ classes.rateReviewChatEndedPopoverContent }
    >
      <RateReview
        visible={ visible }
        onCancel={ () => onCancel(like) }
        existingLike={ like }
        advisorName={ advisorName }
        orderId={ orderId }
        advisorId={ advisorId }
        profileLanguage={ profileLanguage }
        createdAt={ createdAt }
        clickSource={ clickSource }
        theme={ rateReviewTheme.CHAT_ENDED }
        chatType={ chatType }
      />
    </Popover>
  );

  const renderBrowserView = () => (
    <>
      { renderBrowserViewFull() }
    </>
  );

  return (
    isMobile() ? renderMobileView() : renderBrowserView()
  );
}

export default withPGTranslation(RateReviewAfterChat);
